import { FolderService } from '@/services/Folder'
import { useApi } from '@/composables/useApi'

const api = useApi()
export default {
  namespaced: true,
  state: {
    current_folder_id: null,
    folders: [],
    AllMainfolders: [],
    folderAtual: {
      id: 0,
      folder_name: null,
      folder_backet_adress: null,
      id_main: null,
      id_user: null,
      folder_date: null,
      folder_key_name: null,
    },
    params: {
      id_main: 0,
    },
  },
  getters: {},
  mutations: {
    setFolders(state, payload) {
      state.folders = payload
    },
    setIdMainParams(state, payload) {
      state.params.id_main = payload
    },
    setfolderAtual(state, payload) {
      state.folderAtual = payload
    },
    setCurrentFolderId(state, payload) {
      state.current_folder_id = payload
    },
    setAllFoldersMain(state, payload) {
      state.AllMainfolders = payload
    },
  },
  actions: {
    clearFolderAtual({ commit }) {
      commit('setfolderAtual', {
        id: 0,
        folder_name: null,
        folder_backet_adress: null,
        id_main: null,
        id_user: null,
        folder_date: null,
        folder_key_name: null,
      })
    },

    async getAllFolderUser({ state, commit, rootState }) {
      return new Promise(async (resolve, reject) => {
        try {
          await api.get(`/folderUser/${rootState.User.user.id}`, {
            params: state.params,
          })

            .then(resp => {
              const formData = resp.data
              console.log(resp.data)
              formData.map(v => v.is_selected = false)
              commit('setAllFoldersMain', formData)
              resolve(formData)
            })
        } catch (error) {
          reject(error)
        }
      })
    },

    async getAllMoverFolder({ state, commit, rootState }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          await api.get(`/folderUser/${rootState.User.user.id}`, {
            params: payload,
          })

            .then(resp => {
              const formData = resp.data
              formData.map(v => v.is_selected = false)
              resolve(formData)
            })
        } catch (error) {
          reject(error)
        }
      })
    },
    async listarFolders({
      state, commit, dispatch, rootState,
    }) {
      const pastaAtual = JSON.parse(localStorage.getItem('folderATUAL'))
      return new Promise(async (resolve, reject) => {
        try {
          let params = null
          if (state.folderAtual !== null) {
            params = {
              id_main: pastaAtual,
            }
          }
          await api.get(`/folderUser/${rootState.User.user.id}`, {
            params,
          })
            .then(resp => {
              const formData = resp.data
              formData.map(v => v.is_selected = false)
              commit('setFolders', formData)
              dispatch('getAllFolderUser')
              resolve(formData)
            })
        } catch (error) {
          reject(error)
        }
      })
    },
  },
}
